/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "会员卡",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "cover_url",
                name: "封面图片",
                type: "img",
                memo: "建议宽度：750px*360px"
            },
            {
                key: "",
                name: "信息展示",
                type: "checkbox-list",
                "checkbox-list": [{
                        name: "is_micro_app_head_show",
                        text: "小程序头像"
                    },
                    {
                        name: "is_micro_app_name_show",
                        text: "小程序名称"
                    },
                    {
                        name: "is_member_card_name_show",
                        text: "会员卡名称"
                    },
                    {
                        name: "is_account_balance_show",
                        text: "余额"
                    },
                    {
                        name: "is_member_level_show",
                        text: "会员等级"
                    },
                    {
                        name: "is_coupon_show",
                        text: "红包"
                    }
                ]
            }
        ]
    }
];

export default config;